module.exports = __webpack_public_path__ + "img/cloggedcatchbasin.8393cd74.svg";